<template>
  <div id="container" v-loading.fullscreen="disabled">
    <div class="full_layout">
      <div class="shopping_cart">
        <div class="shopping_box">
          <!-- checkout address -->
          <div class="checkout_box">
            <h3>{{$t('base.shipTo')}}<span class="text_blue" style="font-weight: normal;" @click="addChange('','new')" v-if="BusinessType!=2">+{{ $t('base.addNewAddress') }}</span></h3>
            <div class="BusinessType" v-if="BusinessType==2">{{$t('alert.cardHobbyAddress')}}</div>
            <!-- <div class="BusinessType" v-if="BusinessType==2">Cards will be sent to Card Hobby Office in Shanghai China for international
              transaction. You can view them in Oversea Warehouse.</div> -->
            <ul class="address_list" v-if="address!=''||orderAdd!=''">
              <li v-if="orderAdd&&again!=undefined" class="on">
                <div class="choose_address">
                  <div class="on_Default" v-if="orderAdd.IsDefault">{{$t('base.default')}}</div>
                  <div>
                    <span>{{orderAdd.UserName}}</span>
                    ({{orderAdd.Country}})
                  </div>
                  <div class="line_txt2" :title="((orderAdd.StreetAddress !=null ? orderAdd.StreetAddress+',':'')+(orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!='' ? orderAdd.StreetAddress2+',':'')+(orderAdd.City !=null ? orderAdd.City+',':'')+(orderAdd.StateCode !=null ? orderAdd.StateCode+',':'')+orderAdd.ZipCode)">
                    <span>{{orderAdd.StreetAddress !=null ? orderAdd.StreetAddress+', ':''}}</span>
                    <span v-if="orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!=''">{{orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!='' ? orderAdd.StreetAddress2+', ':''}}</span>
                    <span>{{orderAdd.City !=null ? orderAdd.City+', ':''}}</span>
                    <span>{{orderAdd.StateCode !=null ? orderAdd.StateCode+', ':''}}</span>
                    <span>{{orderAdd.ZipCode}}</span>
                  </div>
                  <div>{{orderAdd.Phone}}</div>
                </div>
              </li>
              <li v-for="(item,index) in address" v-if="index<10" :class="isAdd==index&&again==undefined?'on':''">
                <div class="choose_address" @click="addCheck(item,index)">
                  <div class="on_Default" v-if="item.IsDefault">{{$t('base.default')}}</div>
                  <div><span>{{item.UserName}}</span> ({{item.Country}})</div>
                  <div class="line_txt2" :title="((item.StreetAddress !=null ? item.StreetAddress+',':'')+(item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+',':'')+(item.City !=null ? item.City+',':'')+(item.StateCode !=null ? item.StateCode+',':'')+item.ZipCode)">
                    <span>{{item.StreetAddress !=null ? item.StreetAddress+', ':''}}</span>
                    <span v-if="item.StreetAddress2 !=null&&item.StreetAddress2!=''">{{item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+', ':''}}</span>
                    <span>{{item.City !=null ? item.City+', ':''}}</span>
                    <span>{{item.StateCode !=null ? item.StateCode+', ':''}}</span>
                    <span>{{item.ZipCode}}</span>
                  </div>
                  <div>{{item.Phone}}</div>
                </div>
                <span class="change text_blue chage_address" v-if="isAdd==index&&again==undefined" @click="addChange(item,index)">{{$t('base.edit')}}</span>
                <span class="change text_blue chage_address" v-if="again!=undefined" @click="addChange(item,index)">{{$t('base.edit')}}</span>
              </li>
            </ul>
          </div>
          <!-- checkout pay -->
          <div class="checkout_box">
            <h3>{{$t('base.payWith')}}</h3>
            <ul class="pay_list">
              <li :class="checkPay==item.LowerName?'on':''" @click="payCheck(item)" v-for="(item,index) in payChannelsList" :key="index">
                <el-image class="like_img" :src="payChannels[item.LowerName]" fit="contain"></el-image>
              </li>
            </ul>
          </div>
          <!-- {{list}} -->
          <!-- checkout detail -->
          <div class="checkout_box">
            <h3>{{$t('base.reviewItemsShipping')}}</h3>
            <div class="table_head">
              <div class="commod head_box">{{ $t('base.commodity') }}</div>
              <div class="head_box">{{ $t('base.quantity') }}</div>
              <div class="head_box">{{ $t('base.itemPrice') }}</div>
            </div>
            <div class="review_list">
              <div v-for="(item,index) in list.Details">
                <div class="shopping_list">
                  <div class="like_box">
                    <el-image class="like_img" :src="item.TitImg" fit="contain"></el-image>
                    <p class="line_txt4"><span class="line_txt4">{{item.Title}}</span></p>
                  </div>
                  <div class="list_price">
                    {{item.Num?item.Num:item.QuantitySold}}
                  </div>
                  <div class="list_price">
                    {{areaSymbol}} {{item.WorldPrice?item.WorldPrice:item.RealLowestPrice}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Checkout">
          <div class="check_list">
            <span>{{list.Details.length != 1?$t('base.items') :$t('base.item')}} ({{list.Details.length}})</span>
            <span class="price" v-if="again==undefined">{{areaSymbol}} {{total.toLocaleString()}}</span>
            <span class="price" v-if="list.DiscountsPrice<=0&&again!=undefined">{{areaSymbol}} {{total.toLocaleString()}}</span>
            <span class="price" v-if="list.DiscountsPrice>0&&again!=undefined">{{areaSymbol}} {{oldTotal.toLocaleString()}}</span>
          </div>
          <div class="check_list Shipping_list">
            <span class="Shipping_ZipCode">{{ $t('base.shippingTo') }} {{BusinessType==2?'Card Hobby':checkAdd.ZipCode||orderAdd.ZipCode}}</span>
            <span class="price price_s" v-if="postPrice>0">{{areaSymbol}} {{postPrice}}</span>
            <span class="price price_s" v-if="postPrice<=0">{{postageMoney}}</span>
          </div>
          <div class="check_list" v-if="tolist.to === 'buynow'||isOnly">
            <el-select v-model="CouponID" class="info_ipt" :placeholder="TotalCount>0?$t('base.selectCoupons'):$t('base.noCoupon')" @visible-change="SetCommodity(CouponID)" @change="SetCoupon(CouponID)">
              <el-option :label="typeof(item.FreeMoney)=='number'?'-'+areaSymbol+' '+item.FreeMoney:item.FreeMoney" :value="item.ID" v-for="(item,index) in Coupon" :key="index" :disabled="item.disabled">
              </el-option>
            </el-select>
            <span class="text_blue Couponprice">-{{areaSymbol}} {{CouponPrice}}</span>
          </div>
          <div class="check_list" v-if="again!=undefined&&list.DiscountsPrice>0">
            <span>Coupons{{ $t('base.coupons') }}</span>
            <span class="price text_blue">-{{areaSymbol}} {{list.DiscountsPrice.toLocaleString()}}</span>
          </div>
          <div class="check_list check_list_all">
            <span>{{ $t('base.orderTotal') }}</span>
            <span>$ {{again!=undefined?(total.toLocaleString()):(totalPrice(list.total,postPrice))}}</span>
          </div>
          <div class="check_list">
            <i18n path="alert.agreementAPrivacy" tag="p" class="text_gray">
              <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link>
              <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
            </i18n>
          </div>
          <!-- <el-button class="check_btn" type="primary" :disabled="disabled" @click='addOrder' v-if="BusinessType!=2&&again==undefined">
            Confirm and pay</el-button>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='addOrder' v-if="BusinessType==2&&again==undefined">
            Confirm and pay</el-button>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='addOrder' v-if="BusinessType!=2&&again!=undefined">
            Confirm and pay</el-button> -->
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='payOrder()' v-if="BusinessType==2&&again!=undefined">
            {{$t('base.confirmPay')}}</el-button>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='addOrder' v-else>
            {{$t('base.confirmPay')}}</el-button>
          <span class="text_gray finish">{{$t('alert.checkoutOn')}} {{checkPayUpper}}</span>
        </div>
      </div>
    </div>
    <!-- edit address -->
    <get-address v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :checkAdd.sync="checkAdd" :isNew.sync="isNew" :getAreas.sync="getAreas" :userInfo.sync="userInfo" :type='0' />
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import GetAddress from "@/components/dialog/orderaddress"; // 收货地址

import { getInfo, addressList, numAdd, setInfo, isNumber, priceExchange, numMulti, numSub, goPay, GetWorldUSD, setPayList } from "@/api/public";
import qs from 'qs'
export default {
  name: 'index',
  components: {
    GetAddress
  },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      isOnly: false,
      userInfo: '',
      isNew: false,
      CouponPrice: '0',
      CouponID: '',
      Coupon: '',
      disabled: false,
      dialogVisible: false,
      address: [],
      getAreas: '',
      checkAdd: '',
      newAdd: '',
      orderAdd: '',
      orderAddId: 0,
      isAdd: '',
      checkPay: 'stripe',
      checkPayUpper: 'Stripe',
      payChannelsList: [],
      payChannels: this.$enumInfo.payChannels,
      payEnum: this.$enumInfo.paylist,
      IsGuarantee: 6,
      Subtotal: 0,
      num: 1,
      value: '',
      list: '',
      cid: 0,
      DomesticCustom: [],
      BusinessType: '',
      postPrice: 0,
      postageMoney: '',
      again: '',
      tolist: '',
      total: 0,
      oldTotal: 0, //折扣前总价
      TotalCount: 0,
      // ifNoCouons: 'No Coupons',
      IfDefault: true,
      passForm: {
        Country: "US",
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        StateCode: '',
        State: '',
        ZipCode: '',
        Phone: '',
      }
    }
  },
  watch: {
    '$route': 'getPath',
    'list': {
      handler(val) {
        this.total = isNumber(this.list.total);
        //优惠前总价计算
        if (this.list.DiscountsPrice > 0 && this.again != undefined) {
          this.oldTotal = numAdd(this.total, this.list.DiscountsPrice)
          this.oldTotal = numSub(this.oldTotal, this.postPrice)
        }
      }
    },
  },
  mounted() {},
  created() {
    this.userInfo = getInfo()
    GetWorldUSD()
    this.isPayChannels()
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.checkout'));
    this.list = window.sessionStorage.getItem('check');
    //console.log(this.list)
    this.list = JSON.parse(this.list);
    this.total = this.list.total ? this.list.total : 0
    this.tolist = this.list;
    this.isAgain()
  },
  filters: {},
  methods: {
    isPayChannels() {
      let that = this
      let data = { areaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.GetPayChannels, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          data = setPayList(data, that.userInfo, 'stripe')
          // res.Data.map(item => {
          //   item.ChannelName = item.ChannelName.toLowerCase()
          // })
          that.checkPay = data[0].LowerName
          that.checkPayUpper = data[0].ChannelName
          that.IsGuarantee = that.payEnum[that.checkPay]
          that.payChannelsList = data
        } else {
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          if (that.userInfo.MemberSource == 'MO') {
            that.checkPay = 'mpay'
            that.checkPayUpper = 'MPay'
          }
          that.IsGuarantee = that.payEnum[that.checkPay]

        }
      }).catch(res => {
        that.checkPay = 'stripe'
        that.checkPayUpper = 'Stripe'
        if (that.userInfo.MemberSource == 'MO') {
          that.checkPay = 'mpay'
          that.checkPayUpper = 'MPay'
        }
        that.IsGuarantee = that.payEnum[that.checkPay]
      })
    },
    totalPrice(total, post) {
      return numAdd(isNumber(post), isNumber(total)).toLocaleString()
    },
    // 判断是否有订单号
    isAgain() {
      this.again = this.$route.params.id;
      //again:''
      let that = this;

      this.getAddressList();
      this.getAreasList();
      if (this.again != undefined) {
        this.GetOrder()
      } else {
        if (this.tolist.to === 'buynow') {
          this.GetMyCoupon()
        } else {
          if (this.tolist.Details.length == 1 && this.tolist.couponMemberID[0] == 0) {
            this.isOnly = true
            this.GetMyCoupon()
          }
        }
        this.cid = this.list.Details[0].AddressVersionCode
      }

    },
    GetMyCoupon() {
      let that = this;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, pageIndex: 1, pageSize: 99, type: 0 }
      //console.log('data',data)
      this.$get(this.$interface.MyCoupon, data).then(res => {
        //console.log('res',res)
        if (res.Result != 0) {
          let name = "No Coupons"
          // let unusedCoupon = res['data'].filter(obj => { if (obj.Status != 0) return obj });
          // this.Coupon = unusedCoupon;
          this.TotalCount = res.Count;
          if (res.Count > 0) {
            name = "Don'Use";
            res.Data.sort((a, b) => {
              return b.FreeMoney - a.FreeMoney
            })
          }
          // if(this.TotalCount>0){
          //   this.ifNoCouons = 'Select Coupons'
          // }
          res.Data.map(r => {
            r.disabled = false
          })
          this.Coupon = res.Data
          this.Coupon.push({ "ID": 0, 'CouponID': 0, "Title": 'Not applicable', "FreeMoney": name, "IsAllUse": true, 'disabled': false })
        }
      })
    },
    SetCoupon(val) {
      let that = this
      let CouponPrice = 0;
      that.Coupon.map(res => {
        // console.log('res', res)
        if (res.ID == val) {
          //console.log('res',res)
          CouponPrice = res.FreeMoney
        }
      })
      if (val == 0) {
        CouponPrice = 0
      }
      that.CouponPrice = CouponPrice
      that.list.couponMemberID = [val]
      that.list.Details[0]['FreeMoney'] = CouponPrice
      that.list.Details[0]['CouponID'] = val
      that.list.total = that.SetSubtotal(that.list.Details)
      //console.log('that.checkAdd', that.checkAdd)
      that.GetPostPrice(that.checkAdd, 1)
      //console.log('that.list.total',that.SetSubtotal(that.list.Details))
    },
    SetCommodity(val, index) {
      let that = this
      //console.log(val)
      this.Coupon.map(res => {
        if (res.IsAllUse == false) {
          res.disabled = true
          if (res.Commoditys) {
            res.Commoditys.map(r => {
              // console.log(res,r,val, 'r')
              if (r == val) {
                res.disabled = false;
              }
            })
          }
        }
      })
    },
    //根据选中商品更改总价
    SetTotal(obj) {
      let data = obj
      let totalArray = 0
      data.map(res => {
        totalArray = numAdd(totalArray, isNumber(res.RealLowestPrice))
      })
      return totalArray
    },
    // 获取订单详情
    GetOrder() {
      let that = this;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: that.again }
      this.$get(this.$interface.OrdersDetail, data).then(res => {
        if (res.result != 0) {
          let add = res.data.Address

          that.areaSymbol=res.data.RealLowestPriceUnit
          that.checkPay = res.data.IsGuarantee != 3 ? 'stripe' : 'paypal'
          that.IsGuarantee = res.data.IsGuarantee
          if (that.userInfo.MemberSource == "MO") {
            that.checkPay = 'mpay'
            that.IsGuarantee = 9
          }
          if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {
            that.checkPay = that.payChannelsList[0].LowerName
            that.IsGuarantee = that.payEnum[that.checkPay]
          }
          //that.checkPay='Stripe'
          if (add) {
            if (add.indexOf('()') > 0) {
              // var a=add1.indexOf('()')
              // console.log(add1,a,'add2',add1.substring(0,a))
              //var reg=new RegExp()
              add = add.replace(/\(\)/g, "")

              add = [add]
              //console.log(add1,a,'add1')
            } else {
              add = add.replace(")", "")
              add = add.replace("(", "|")
              add = add.split("|")
            }
          }
          // 重组地址信息
          let result = {
            UserName: res.data.Consignee,
            Country: res.data.Nation,
            StreetAddress: add[0] ? add[0] : add,
            StreetAddress2: add[1] ? add[1] : '',
            ZipCode: res.data.ZipCode,
            City: res.data.City,
            State: res.data.Provice,
            Phone: res.data.Mobile,
            StateCode: '',
          }
          res.data.total = res.data.RealTotalPrice
          this.list = res.data
          this.postPrice = res.data.RealPostageMoney
          if (res.data.RealPostageMoney <= 0) {
            this.postageMoney = 0
          }
          this.postageMoney = res.data.NewPostageMoney;
          if (this.again != undefined) {
            if (this.getAreas) {
              this.getAreas.map(item => {
                if (result.State == item.EName) {
                  result.StateCode = item.Code
                }
              })
            }
            this.orderAdd = result;
            this.setOrderAddressList(result)
          }
          that.disabled = false
        }

      })
    },
    //去重收货地址
    setOrderAddressList(obj) {
      let that = this
      let add = that.address
      add.map((res, i) => {
        let oldadd = res.City + res.Country + res.Phone + res.state + res.StateCode + res.StreetAddress + res.StreetAddress2 + res.UserName + res.ZipCode
        let newadd = obj.City + obj.Country + obj.Phone + obj.state + obj.StateCode + obj.StreetAddress + obj.StreetAddress2 + obj.UserName + obj.ZipCode
        if (oldadd == newadd) {
          if (res.IsDefault) {
            that.orderAdd.IsDefault = true
          }
          that.orderAddId = res.Id
          this.address.splice(i, 1)
        }
      })


      if (that.again != undefined) {
        if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {

          var ChannelName = that.payChannelsList[0].LowerName
          if (that.checkPay != ChannelName) {
            that.payCheck(that.payChannelsList[0])
          }

        }
      }
      // console.log(that.address, obj, 'that.address')
    },
    //新增订单and 更新订单
    addOrder() {
      let that = this

      if (this.again != undefined) {

        that.disabled = false;
        that.payOrder()
        //goPay(this.checkPay,'pay',('?id=' + orderid))
        //window.location.href = this.$interface.pay + '?id=' + that.again
      } else {
        that.disabled = true;
        //判断是否从一口价进来的checkout
        if (this.tolist.to === 'buynow') {
          // console.log(this.tolist.to, 'this.tolist.to')
          this.setOrder()
        } else {
          this.getCart()
        }
      }
    },
    // 验证购物车与session中商品是否有交集
    getCart() {
      let that = this
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, isWorld: 0 }
      this.$get(this.$interface.GetMyCart, data).then(res => {
        if (res.result != 0) {
          let list = that.list.commodityIds
          let result = res.data
          if (result.length > 0) {
            let newRes = []
            let isNo = 0;
            result.map(r => {
              newRes.push(r.CommodityId)
            })
            // 购物车与session中商品是否有交集
            isNo = list.filter(v => { return newRes.indexOf(v) > -1 })
            // 有交集重组session中商品
            if (isNo != 0) {
              let newCommodityIds = []
              let newCuantitySold = []
              let newCouponMemberID = []
              let newDetails = []
              //CommodityIds: that.list.commodityIds, QuantitySold: that.list.cuantitySold, couponMemberID: that.list.couponMemberID
              isNo.map(item => {
                that.list.Details.map(r => {
                  if (item == r.CommodityId) {
                    newCommodityIds.push(r.CommodityId)
                    newCuantitySold.push(r.Num)
                    newCouponMemberID.push(r.Coupon || r.CouponID)
                    newDetails.push(r)
                  }
                })
              })

              that.list.Details = newDetails
              that.list.commodityIds = newCommodityIds
              that.list.cuantitySold = newCuantitySold
              that.list.couponMemberID = newCouponMemberID
              that.list.total = that.SetSubtotal(that.list.Details)
              this.setOrder()
            } else {
              this.$message({
                type: 'error',
                message: 'The order has already been placed'
              });

              that.disabled = false
            }
          } else {

            this.$message({
              type: 'error',
              message: 'The order has already been placed'
            });
            that.disabled = false
            //   this.$message({
            //     type: 'error',
            //     message: '相关商品已生成订单'
            //   });
          }
          //CommodityId
          // let isNo = 0;
          // result.map(r => {
          //   list.map(item => {
          //     if (r.CommodityId == item.CommodityId) {
          //       isNo++
          //     }
          //   })
          // })
        } else {

        }
      })
    },
    //根据选中商品更改总价
    SetSubtotal(obj) {
      // console.log('obj', obj)
      let data = obj
      let totalArray = 0;
      let CouponArray = 0;
      let Subtotal = 0
      data.map(res => {
        //商品合计总价
        totalArray = numAdd(isNumber(totalArray), numMulti(isNumber(res.WorldPrice), isNumber(res.Num)))
        //商品合计优惠券总价
        CouponArray = numAdd(isNumber(CouponArray), isNumber(res.FreeMoney == undefined || res.FreeMoney == null ? 0 : res.FreeMoney))

      })
      // 商品扣除优惠券后总价
      Subtotal = numSub(totalArray, CouponArray) > 0 ? numSub(totalArray, CouponArray) : 0
      return Subtotal
    },
    //提交订单并支付
    setOrder() {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, AddressID: that.checkAdd.Id, IsGuarantee: that.IsGuarantee, GBC: 0, CommodityIds: that.list.commodityIds, QuantitySold: that.list.cuantitySold, couponMemberID: that.list.couponMemberID }
      let msg = "You have not set your shipping address!"
      if (this.address.length <= 0) {
        this.$message({
          type: 'error',
          // message: res.msg
          message: msg
        });
        that.disabled = false
      } else {
        this.$post(this.$interface.OfficialAddOrder, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            let orderid = res.data[0].OrderID
            if (res.data[0].OrderStatus == 2) {
              this.$router.push({
                path: '/mycardhobby/purchase?type=2'
              })
            } else if (res.data[0].OrderStatus == 1) {

              this.payOrder(orderid)
            }

            //window.location.href = this.$interface.pay + '?id=' + orderid
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
            that.disabled = false
          }
        })
      }
    },
    // 支付
    payOrder(id) {
      var orderid = id && id != null ? id : this.again
      //goPay('pay', ('?id=' + this.again))
      if (this.userInfo.MemberSource == 'MO') {
        goPay('Mpay', ('?id=' + orderid))
      } else {
        if (this.checkPay == 'stripe') {
          goPay('pay', ('?id=' + orderid))
        } else {
          goPay('paypal', ('?paysource=1&id=' + orderid))
        }
      }
      //window.location.href = this.$interface.pay + '?id=' + this.again
    },
    // 获取邮费
    GetPostPrice(obj, type) {
      let that = this;
      let orderPrice = priceExchange(isNumber(that.list.total))
      let data = { memberid: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, addressId: obj.Id, orderPrice: orderPrice }
      // console.log(data)
      this.$get(this.$interface.GetCartPostageMoney, data).then(res => {
        if (res.result != 0) {
          this.postPrice = res.data.USPostMoney != null ? res.data.USPostMoney : 0
          this.postageMoney = res.data.PostageMoneyStr
        }
        // console.log(res, 'ress')
      })

    },
    //获取地址列表 type新添加地址
    getAddressList(type) {
      let that = this
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result != 0) {
          this.address = res.Data
          if (type) {
            var endLength = this.address.length - 1
            this.GetPostPrice(this.address[endLength])
            this.checkAdd = this.address[endLength]
            // console.log(this.checkAdd, '11111')
            this.isAdd = endLength;
            if (that.again != undefined) {
              that.setOrderAddressList(that.orderAdd);
            }
          } else {
            if (that.again != undefined) {
              //订单列表或详情进入 去重收货地址
              if (that.orderAdd) {
                that.setOrderAddressList(that.orderAdd);
                //that.GetServiceFee(2, that.orderAdd)
              }
            } else {
              if (this.isAdd > 0) {
                this.GetPostPrice(this.address[this.isAdd])
                this.checkAdd = this.address[this.isAdd]
                // console.log(this.checkAdd, '22222')
              } else {
                if (res.Count.length > 1) {
                  this.address.map((val, i) => {
                    if (val.IsDefault) {
                      //console.log(val)
                      this.GetPostPrice(val)
                      this.checkAdd = val
                      // console.log(this.checkAdd, '333333')
                      this.isAdd = i;
                    }
                  })
                } else {
                  this.GetPostPrice(this.address[0])
                  this.checkAdd = this.address[0]
                  // console.log(this.checkAdd, '44444')
                  this.isAdd = 0;
                }
              }
            }
          }
        }
      })
    },
    //获取地区列表
    getAreasList() {
      let that = this;
      let data = { code: that.userInfo.MemberSource }
      this.$get(this.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
        }
      })
    },
    //设置地址选中
    addCheck(obj, val) {
      let that = this
      if (this.again != undefined) {
        //更新订单
        // console.log(obj,'obj')
        this.disabled = true;
        let data = { MemberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, AddressID: obj.Id, OrderId: that.list.ID, IsGuarantee: that.IsGuarantee, GBC: 0, CommodityIds: '', QuantitySold: '', couponMemberID: '' }
        let url = that.$interface.OfficialAddOrder
        this.$post(url, qs.stringify(data)).then(res => {
          if (res.result != 0) {

            that.getAddressList();
            that.GetOrder()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
            this.addloading = false
          }
        })
      } else {
        if (val != this.isAdd) {
          this.isAdd = val;
          this.checkAdd = obj
          // console.log(this.checkAdd, '55555')
          this.GetPostPrice(obj)
        }
      }
    },
    //select 州
    // getState(val) {
    //   let that = this
    //   that.getAreas.map(res => {
    //     if (res.Code == val) {
    //       that.checkAdd.State = res.EName
    //     }
    //   })
    // },
    //设置支付方式
    payCheck(val) {
      let that = this
      this.checkPay = val.LowerName;
      this.checkPayUpper = val.ChannelName;
      this.IsGuarantee = this.payEnum[val.LowerName]
      // if (that.again != undefined) {
      //   let data = { MemberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, AddressID: that.orderAddId, OrderId: that.list.ID, IsGuarantee: (that.checkPay != 'Stripe' ? 3 : 6), GBC: 0, CommodityIds: '', QuantitySold: '', couponMemberID: '' }
      //   let url = that.$interface.OfficialAddOrder
      //   this.$post(url, qs.stringify(data)).then(res => {
      //     if (res.result != 0) {

      //       that.getAddressList();
      //       that.GetOrder()
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: res.msg
      //       });
      //       this.addloading = false
      //     }
      //   })
      // }
    },
    //新增地址
    addChange(obj, val) {
      this.dialogVisible = true
      // console.log(obj, '1231231231')
      if (val == 'new') {
        this.isNew = true;
        this.newAdd = this.checkAdd;
        if(this.userInfo.MemberSource=="MO"){
          this.passForm.Country=this.userInfo.MemberSource
        }
        this.checkAdd = this.passForm;
        this.IfDefault = false;
      } else {
        this.isNew = false;
        this.checkAdd = obj;
        this.IfDefault = true;
      }
    },
    //保存地址
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": that.userInfo.Id,
            "country": that.checkAdd.Country,
            "userName": that.checkAdd.UserName,
            "streetAddress": that.checkAdd.StreetAddress,
            "streetAddress2": that.checkAdd.StreetAddress2,
            "city": that.checkAdd.City,
            "stateCode": that.checkAdd.StateCode,
            "state": that.checkAdd.State,
            "zipCode": that.checkAdd.ZipCode,
            "phone": that.checkAdd.Phone
          }
          if (!this.isNew) {
            url = this.$interface.UpdateAddresses;
            data.id = that.checkAdd.Id
            data.isDefault = that.checkAdd.IsDefault
          }
          this.$post(url, data).then(res => {
            if (res.Result != 0) {
              this.getAddressList(this.isNew);
              that.dialogVisible = false
              that.disabled = false
              that.$refs[formName].resetFields();
            } else {
              that.disabled = false
              this.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })
          //console.log(url, data)
        }
      });
      //this.dialogVisible = false
    },
    //取消保存地址
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.checkAdd = this.newAdd;
      this.dialogVisible = false
    }
  },
  //离开页面后
  destroyed() {

    //alert(2);
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.shopping_cart {
  margin: 40px 0;
}

.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
}

.checkout_box h3>span {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
}

.shopping_box {
  border: none;
}

.shopping_list {
  width: 100%;
  padding: 8px 12px;
}

.shopping_list .like_box {
  display: flex;
  position: relative;
  width: 525px;
}

.shopping_list .like_box p {
  width: 425px;
}

.shopping_list .list_price {
  width: 120px;
  text-align: right;
  padding: 0 5px;
}

.avatar_box {
  display: flex;
  height: 40px;
  line-height: 40px;
  background-color: #f7f7f7;
  padding: 0 12px;
}

.avatar {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-top: 12px;
  margin-right: 5px;
}

.review_list {
  border: 1px solid #e0e0e0;
  margin-top: 20px;
}

.table_head {
  height: 48px;
  line-height: 48px;
  display: flex;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
}

.head_box {
  width: 150px;
  padding: 0 12px;
  text-align: right;
}

.commod {
  width: 545px;
  padding-left: 110px;
  text-align: left;
}

.address_list,
.pay_list {
  display: flex;
  flex-wrap: wrap;
}

.address_list li {
  height: 145px;
  border: 2px dashed #e0e0e0;
  margin-right: 8px;
  margin-bottom: 32px;
  padding: 0;
  min-height: 100px;
  width: 278px;
  position: relative;
  cursor: pointer;
}

.address_list li:nth-child(3n) {
  margin-right: 0;
}

.address_list li.on {
  border-color: #5f6dae;
}

.address_list li.on::after {
  content: "";
  border: 15px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -2px;
  bottom: -2px;
}

.address_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 4px;
  height: 10px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 5px;
  z-index: 2;
}

.address_list li>.choose_address {

  box-sizing: border-box;
  padding: 20px;
  width: 278px;
  padding-bottom: 30px
}

.choose_address>div {
  margin-bottom: 10px;
}

.address_list li>div {
  margin-bottom: 10px;
}

.address_list li>div span {
  margin-right: 5px;
}

.address_list li.on .change {
  position: absolute;
  z-index: 2;
  right: 12px;
  bottom: 24px;
  font-size: 14px;
  margin: 0;
  left: auto;
}

.pay_list li {
  border: 1px solid #c8c8c8;
  position: relative;
  cursor: pointer;
  width: 185px;
  margin-right: 20px;
  margin-bottom: 32px;
  height: 38px;
  text-align: center;
}

.pay_list li .like_img {
  width: 100px;
  height: 24px;
  margin-top: 8px;
}

.pay_list li.on {
  border-color: #5f6dae;
  background: #f0f3ff;
}

.pay_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.pay_list li.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -1px;
  bottom: -1px;
}

.info_box {
  width: 240px;
  margin-left: 24px;
}

.address_box {
  width: 100%;
  display: flex;
}

.address_list_box {
  width: 160px;
}

.checkbox_save {
  margin-left: 24px;
}

.dialogBox {
  width: 875px;
}

.set_btn {
  text-align: right;
}

.Checkout {
  font-weight: normal;
}

.check_list_all,
.check_list .price {
  font-weight: bold;
}

.price_s {
  text-align: right;
  /*  font-weight: normal !important;*/
}

.check_list .price {
  text-align: right;
}

.check_list .Couponprice {
  font-weight: bold;
  line-height: 36px;
}

.check_list .info_ipt {
  width: 150px;
}

.finish {
  margin: 10px auto 0;
  display: block;
  text-align: center;
}

.BusinessType {
  font-size: 16px;
  padding-bottom: 20px;
}

.el-select-dropdown li:hover {
  text-decoration: none;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}

.line_txt4 {
  height: 78px;
}

.shopping_list .like_box p .line_txt4 {
  display: -webkit-box;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/cartcheckout.vue